import { render } from "./Portal.vue?vue&type=template&id=48d2e384&ts=true"
import script from "./Portal.vue?vue&type=script&lang=ts"
export * from "./Portal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2728993903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__